class VideoElement {
    constructor(element) {
      this.element = element
      this.playButtonEl = this.element.querySelector('[data-video-element-play-button]')
      this.videoEl = this.element.querySelector('[data-video]')
      this.durationEl = this.element.querySelector('[data-video-duration]')
 
    
      this.videoEl.addEventListener("canplay", () => {
        const duration = this.videoEl.duration
        this.durationEl.innerText =  (duration / 60).toFixed(2).replace('.', ':')
      })

      if (this.playButtonEl) {
        this.playButtonEl.addEventListener('click', () => this.playPause() )
      }

    }

    playPause(){
       this.videoEl.paused === true ? this.videoEl.play() : this.videoEl.pause()
       this.playButtonEl.classList.toggle('play--paused', this.videoEl.paused === false)
    }
  }
  
  export default VideoElement